const styles = (theme) => ({
  dropDownIndicator: {
    color: theme.iconColor,
    height: 16,
    width: 32,
  },
  stopsSelectFilter: {
    display: "inline-block",
    paddingLeft: 0,
    minWidth: 220,
    "& .select__control": {
      minWidth: 220,
      maxWidth: "100%",
      minHeight: 32,
      boxSizing: "border-box",
      borderRadius: "5px",
      marginTop: 0,
      fontSize: theme.textFontSize,
      cursor: "inherit",
      "&:hover,&.select__control--is-focused": {
        boxShadow: "none",
        backgroundColor: "inherit",
        border: `1px solid ${theme.palette.primary.main}`,
      },
      "&.select__control": {
        backgroundColor: "inherit",
      },
      "& .select__value-container": {
        minHeight: 24,
        color: theme.TextColor,
        backgroundColor: "inherit",
        padding: "0px 8px",
        "& .select__input": {
          height: 22,
          color: theme.TextColor,
          "&>input": {
            height: 22,
          },
        },
        "&>div": {
          margin: 0,
        },
        "&>.select__multi-value": {
          margin: 2,
          backgroundColor: theme.HeaderSelectedText,
          "&>div": {
            color: "inherit",
            padding: 4,
          },
          "& .select__multi-value__remove": {
            padding: "4px 0",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: theme.HeaderSelectedText,
            },
          },
        },
      },
      "& .select__single-value": {
        color: theme.TextColor,
      },
      "& .select__indicators": {
        height: 24,
        "& .select__indicator": {
          padding: 4,
          height: 20,
        },
        "& .select__clear-indicator": {
          padding: 4,
          height: 20,
          color: theme.headerIconColor,
          cursor: "pointer",
        },
        "& .select__indicator-separator": {
          height: 24,
          margin: 0,
          display: "none",
        },
      },
    },

    "& .select__menu": {
      margin: 0,
      maxHeight: 160,
      borderRadius: 2,
      "& .select__menu-list": {
        maxHeight: 158,
        borderRadius: 2,
        fontSize: theme.textFontSize,
        backgroundColor: theme.ModalBGColor,
      },
      "& .select__menu-list--is-multi": {
        maxHeight: 158,
        borderRadius: 2,
        fontSize: theme.textFontSize,
        backgroundColor: theme.ModalBGColor,
      },
      "& .select__option": {
        cursor: "pointer",
        color: theme.TextColor,
      },
      "& .select__option--is-focused": {
        backgroundColor: theme.HighlightColor,
        cursor: "pointer",
      },
      "& .select__option--is-selected": {
        backgroundColor: theme.HighlightColor,
        color: theme.TextColor,
      },
    },
  },
  checkBox: {
    padding: 2,
    color: theme.iconColor,
  },
  filterButton: {
    color: theme.TextColor,
    padding: "4px 8px",
    width: "100%",
    border: `1px solid ${theme.iconColor}`,
    fontSize: theme.textFontSize,
  },
  filterButtonText: {
    width: "100%",
    textAlign: "left",
  }
});

export default styles;
